import * as actions from './actions';
import * as api from './api';
import * as functions from './functions';
import reducer from './reducer';

const reducers = {
  membershipData: reducer,
};

export {
 actions, api, functions, reducers,
};
